import React, { Component } from "react";

// View only: shows the purple switch button, current selection and the options menu.
// Saving / state lives in the parent (CoverPage) via `onChange`.
class CoverPhotoSwitcher extends Component {
  state = { menuOpen: false };

  select = (useAlternate) => {
    const { onChange } = this.props;
    if (onChange) onChange(useAlternate);
    this.setState({ menuOpen: false });
  };

  render() {
    const { useAlternatePhoto, saving } = this.props;
    const { menuOpen } = this.state;
    return (
      <div className="cover-photo-switch-button">
        <div
          className="cover-photo-switch-header"
          onClick={() => this.setState({ menuOpen: !menuOpen })}
        >
          <p>Switch to Alternate Cover Photo</p>
          <p className="current-selection">
            Current Selection: {useAlternatePhoto ? "Alternate" : "Default"}
            {saving ? " (saving...)" : ""}
          </p>
        </div>
        {menuOpen && (
          <div className="cover-photo-switch-options">
            <div
              className={!useAlternatePhoto ? "selected" : ""}
              onClick={() => this.select(false)}
            >
              Default
            </div>
            <div
              className={useAlternatePhoto ? "selected" : ""}
              onClick={() => this.select(true)}
            >
              Alternate
            </div>
            <div
              className="close-option"
              onClick={() => this.setState({ menuOpen: false })}
            >
              Close
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default CoverPhotoSwitcher;
